import React from "react";

import getColourHex from "../../utils/colours";

const Wrapper = ({ children, bgColourType }) => {

    let bgColour = getColourHex(bgColourType);

    return (
        <div style={{
            backgroundColor: bgColour
        }}>
            { children }
        </div>
    );
}

export default Wrapper;